module.exports = "/lucky-balls/img/bigball/BigBall_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_023.png
// module id = 918
// module chunks = 0